/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Grid from "@mui/material/Grid";
import { useState, useEffect } from "react";
// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import React from "react";
// Material Dashboard 2 React example components
import DashboardLayout from "../../examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "../../examples/Navbars/DashboardNavbar";
import Footer from "../../examples/Footer";
import Button from "components/ButtonUse";
import EditIcon from "@mui/icons-material/Edit";
import AddIcon from "@mui/icons-material/Add";
import useSWR from "swr";
import arrowimg from "../../assets/images/arrowimg.png";

import reportsLineChartData from "../../layouts/dashboard/data/reportsLineChartData";

// Dashboard components

import Box from "@mui/material/Box";
import { DataGrid } from "@mui/x-data-grid";
import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import DeleteIcon from "@mui/icons-material/DeleteOutlined";
import SaveIcon from "@mui/icons-material/Save";
import CancelIcon from "@mui/icons-material/Close";
import { MdOutlinePreview } from "react-icons/md";
import { FaEdit } from "react-icons/fa";
import { MdDelete } from "react-icons/md";
import LoaderComponent from "components/Loader";
import SnackBarComponent from "components/AlerComponent";
import { baseUrl } from "utils/api";
import axios from "axios";
import ModalComponent from "components/ModalComponent";
import Select from "react-select";
import * as XLSX from "xlsx";
import {
  GridRowModes,
  GridToolbarContainer,
  GridActionsCellItem,
  GridRowEditStopReasons,
} from "@mui/x-data-grid";
import { useNavigate } from "react-router-dom";

function CategoryList() {
  const navigate = useNavigate();
  // fetch data swr
  const [loading, setLoading] = useState(false);
  const [datas, setDatas] = useState([]);
  const [file, setFile] = useState("");
  const [showSnack, setShowSnack] = useState(false);
  const [initialRows, setInitialRows] = useState([]);
  const closeSnack = () => {
    setShowSnack(false);
  };
  useEffect(() => {
    async function fetchData() {
      setLoading(true);
      const { data } = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/categories/getCategoriesV2?page=1`
      );
      setLoading(false);
      setDatas(data?.data);
      setInitialRows(
        data?.data?.map((mydata) => ({
          ...mydata,
          image: { arrowimg },
        }))
      );
    }
    fetchData();
    console.log("initialRows", initialRows);
  }, []);

  const [pinned, setPinned] = useState(false);
  const [showModal, setShowModal] = useState(false);

  const handleCloseModal = () => {
    setShowModal(false);
  };

  const handleShowModal = () => {
    setShowModal(true);
  };

  const handleEditClick = (id) => () => {
    setRowModesModel({ ...rowModesModel, [id]: { mode: GridRowModes.Edit } });
  };

  const handleCancelClick = (id) => () => {
    setRowModesModel({
      ...rowModesModel,
      [id]: { mode: GridRowModes.View, ignoreModifications: true },
    });
  };
  const handleSaveClick = async (id, categoryData) => {
    setRowModesModel({ ...rowModesModel, [id]: { mode: GridRowModes.View } });
  };

  const handleDeleteCategory = async (id) => {
    try {
      const res = await axios.get(`${process.env.REACT_APP_BASE_URL}/store/delete/${id}`);
      if (res.status === 200) {
      }
    } catch (error) {
      console.log(error);
    }
  };

  const fetchData = async (url) => {
    try {
      const response = await axios.get(url);
      return response.data;
    } catch (error) {
      console.log(error);
    }
  };

  const handlePinCateory = async (id, value) => {
    try {
      // setPinned(true);
      setFormLoading(true);
      const res = await axios.post(`${process.env.REACT_APP_BASE_URL}/edit-category/${id}`, {
        pinned: value,
      });
      if (res.status === 200) {
        console.log(res.data);
        setFormLoading(false);
      }
    } catch (error) {
      setFormLoading(false);

      console.log(error);
    }
  };

  const [selectedTableRow, setSelectedRow] = useState(false);
  const exportToExcel = () => {
    const data = datas;

    const ws = XLSX.utils.json_to_sheet(data);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
    XLSX.writeFile(wb, "data.xlsx");
  };
  const columns = [
    {
      field: "id",
      headerName: "Id",
      width: "250",
    },
    // { field: "id", headerName: "ID", width: 150 },
    {
      field: "category",
      headerName: "Category Name",
      width: 400,
    },
    {
      field: "sortOrder",
      headerName: "Sort No.",
      width: 100,
      editable: true,
    },
    {
      field: "pinned",
      headerName: "Pinned",
      width: 100,
      renderCell: (params) => {
        console.log(params);
        return (
          <>
            <input
              type="checkbox"
              checked={params.row.pinned}
              onChange={(e) => handlePinCateory(params.row.id, e.target.checked)}
            />
          </>
        );
      },
      // editable: true,
    },
    {
      field: "categoryImage",
      headerName: "Image",
      width: 100,
      renderCell: (params) => (
        <>
          <div>
            <img
              src={
                params.row?.categoryImage ? params.row?.categoryImage : params.row.image.arrowimg
              }
              // alt={`User ${params.row.id}`}
              style={{ width: "50px", height: "50px", borderRadius: "50%" }}
            />
          </div>
        </>
      ),
    },
    {
      field: "Minimal weight kg",
      headerName: "Min. Weight",
      width: 150,
      editable: true,
    },
    {
      field: "Minimal size",
      headerName: "Min. Size",
      width: 150,
      editable: true,
    },
    {
      field: "Delivery by train",
      headerName: "By Train",
      width: 100,
      editable: true,
    },
    {
      field: "Delivery by air",
      headerName: "By Air",
      width: 100,
      editable: true,
    },

    {
      field: "Profit",
      headerName: "Profit%",
      width: 100,
      editable: true,
    },
    {
      field: "Show or not",
      headerName: "isBodyData",
      width: 100,
      editable: true,
    },
    {
      field: "action",
      headerName: "Action",
      description: "This column has a value getter and is not sortable.",
      sortable: false,
      width: 100,
      renderCell: (param) => {
        console.log(param.row, "PAramRow");
        return (
          <>
            <div style={{ display: "flex", gap: "6px" }}>
              <Tooltip onClick={() => navigate("/view_details", { state: param.id })} title="view">
                <IconButton>
                  <MdOutlinePreview style={{ cursor: "pointer" }} />
                </IconButton>
              </Tooltip>
              <Tooltip
                onClick={() =>
                  navigate("/edit-category", { state: { category: { _id: param.row.id } } })
                }
                title="Edit"
              >
                <IconButton>
                  <FaEdit className="text-blue-400" style={{ cursor: "pointer" }} />
                </IconButton>
              </Tooltip>
              {/* <Tooltip onClick={() => handleDeleteCategory(param.id)} title="Delete">
                                <IconButton>
                                    <MdDelete className="text-red-500" style={{ cursor: "pointer" }} />
                                </IconButton>
                            </Tooltip> */}
            </div>
          </>
        );
      },
      valueGetter: (params) => `${params.row.Name || ""} ${params.row.lastName || ""}`,
    },
    {
      field: "actions",
      type: "actions",
      headerName: "Quick Edit",
      width: 100,
      cellClassName: "actions",
      getActions: (params) => {
        const isInEditMode = rowModesModel[params.id]?.mode === GridRowModes.Edit;

        if (isInEditMode) {
          return [
            <GridActionsCellItem
              icon={<SaveIcon />}
              label="Save"
              sx={{
                color: "green",
              }}
              onClick={() => {
                const rowWithoutImage = Object.entries(params.row).reduce((acc, [key, value]) => {
                  if (key !== "image") {
                    acc[key] = value;
                  }
                  return acc;
                }, {});
                console.log(rowWithoutImage);
                handleSaveClick(params.id, rowWithoutImage);
                // window.location.reload();
              }}
            />,
            <GridActionsCellItem
              icon={<CancelIcon />}
              label="Cancel"
              className="textPrimary"
              onClick={handleCancelClick(params.id)}
              color="inherit"
            />,
          ];
        }
        return [
          <GridActionsCellItem
            icon={<EditIcon className="text-blue-400" />}
            label="Edit"
            className="textPrimary"
            onClick={handleEditClick(params.id)}
            color="inherit"
          />,
        ];
      },
      valueGetter: (params) => `${params.row.Name || ""} ${params.row.lastName || ""}`,
    },
  ];
  const [updatedNewRow, setUpdatedRow] = useState(null);

  const [rows, setRows] = useState(initialRows);
  const [rowModesModel, setRowModesModel] = useState({});
  const processRowUpdate = async (newRow) => {
    const updatedRow = { ...newRow, isNew: false };
    setUpdatedRow(updatedRow);
    console.log(newRow);
    await handleUpdateCategory(newRow.id, newRow);
    setRows(rows.map((row) => (row.id === newRow.id ? updatedRow : row)));

    return updatedNewRow;
  };

  const [allIds, setAllIds] = useState([]);

  const [formLoading, setFormLoading] = useState(false);
  function handleFileUpload(event, exclFile) {
    const file = exclFile;
    const reader = new FileReader();

    reader.onload = function (event) {
      // Parse data
      const bstr = event.target.result;
      const workbook = XLSX.read(bstr, { type: "binary" });

      // Get first worksheet
      const worksheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[worksheetName];

      // Convert to JSON
      const jsonData = XLSX.utils.sheet_to_json(worksheet, {
        raw: false, // Include formatted text in cells
        defval: "", // Default value for missing keys (blank keys)
      });
      console.log(jsonData, "JsonData");
      const excelCat = jsonData?.map((cat) => {
        console.log(cat,'CCCAATT')
        return {
          categories: cat["category"].split("/"),
          details: Object.keys(cat).reduce((acc, key) => {
            if (key !== "category") {
              acc[key] = cat[key];
            }
            return acc;
          }, {}),
        };
      });
      axios.post(`${process.env.REACT_APP_BASE_URL}/categories/updateExcelCategoriesV2`, excelCat);
      console.log(excelCat, "ExcelDATACat");
    };

    reader.readAsBinaryString(file);
  }
  const handleSubmit = async (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append("file", file);
    handleFileUpload(e, file);
    try {
      setFormLoading(true);
      const res = await axios.post(`${process.env.REACT_APP_BASE_URL}/upload-category`, formData);
      console.log(res);
      if (res.status === 200) {
        setFormLoading(false);

        navigate("/");
      }
    } catch (error) {
      setFormLoading(false);

      console.log(error);
    }
  };

  const handleRowEditStop = (params, event) => {
    if (params.reason === GridRowEditStopReasons.rowFocusOut) {
      event.defaultMuiPrevented = true;
    }
  };
  const handleRowModesModelChange = (newRowModesModel) => {
    setRowModesModel(newRowModesModel);
  };

  async function handleUpdateCategory(id, obj) {
    try {
      setFormLoading(true);

      const res = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/edit-category/${id}`,
        {
          ...obj,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (res.status === 200) {
        setFormLoading(false);
      }
      setFormLoading(false);
    } catch (error) {
      setFormLoading(false);
      console.log(error);
    }
  }

  const [enableSelection, setEnableSelection] = useState(false);

  const handleEnableSelection = () => {
    setEnableSelection(!enableSelection);
  };

  const onRowsSelectionHandler = (ids) => {
    const selectedRowsData = ids.map((id) => initialRows.find((row) => row.id === id));
    const foundIds = selectedRowsData.map((d) => d.id);
    setAllIds(foundIds);
  };

  const handleDeleteSelectedRows = async () => {
    let result = confirm("Are you sure you want to delete?");
    if (!result) {
      return;
    }
    try {
      setFormLoading(true);
      const res = await axios.post(`${process.env.REACT_APP_BASE_URL}/delete/categories`, {
        ids: allIds,
      });
      setShowSnack(true);
      setFormLoading(false);
    } catch (error) {
      setFormLoading(false);
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      {!initialRows && <LoaderComponent open={true} />}
      {formLoading && <LoaderComponent open={true} />}
      <MDBox py={3}>
        <form
          style={{ paddingBottom: "20px", display: "flex", gap: "20px", alignItems: "center" }}
          onSubmit={handleSubmit}
        >
          <div className="flex" style={{marginLeft:"43rem"}}>
            <div className="flex flex-col">
              <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                <label htmlFor="fileSelect">
                  <span className="bg-green-700   rounded-md w-[10vw] cursor-pointer p-2 border-none outline-none ml-[1vw] text-white  text-sm">
                    Choose Excel File
                  </span>
                  {/* <span
                    style={{
                      background: "green",
                      padding: "10px",
                      borderRadius: "5px",
                      fontSize: "small",
                      color: "white",
                      cursor: "pointer",
                      height: "15vh"
                    }}
                  >
                    Choose Excel file
                  </span> */}
                </label>

                <input
                  style={{ display: "none" }}
                  type="file"
                  id="fileSelect"
                  onChange={(e) => setFile(e.target.files[0])}
                  accept=".xlsx, .xls, .csv"
                />
                <span className="text-sm">{file.name}</span>
              </div>
              {file && (
                <button
                  type="submit"
                  className="bg-green-700 rounded-md w-[10vw] cursor-pointer p-2 border-none outline-none text-white"
                >
                  Submit
                </button>
              )}
            </div>
            {/* <span>{file.name}</span> */}
            <div className="flex">
              <label>
                <span
                  onClick={() => navigate("/add-category")}
                  type="button"
                  className="bg-blue-700  rounded-md w-[10vw] text-sm cursor-pointer p-2 border-none outline-none ml-[1vw] text-white"
                >
                  Upload Manually
                </span>
              </label>
            </div>
            <div className="flex">
              <label>
                <span
                  onClick={handleEnableSelection}
                  type="button"
                  className="bg-purple-700  rounded-md w-[10vw] text-sm cursor-pointer p-2 border-none outline-none ml-[1vw] text-white"
                >
                  Enable Selection
                </span>
              </label>
            </div>
            <div className="flex">
              <label>
                <span
                  onClick={exportToExcel}
                  type="button"
                  className="bg-purple-700  rounded-md w-[10vw] text-sm cursor-pointer p-2 border-none outline-none ml-[1vw] text-white"
                >
                  Export Data
                </span>
              </label>
            </div>
          </div>
          {/* <div style={{ marginLeft: "10vw" }}>
            <Button type={"submit"} background={"green"} title={"Submit"} />
          </div> */}
        </form>
        {allIds.length > 0 && (
          <label>
            {" "}
            <span
              onClick={handleDeleteSelectedRows}
              type="button"
              className="bg-red-700 h-[5vh] rounded-md text-sm w-[10vw] cursor-pointer p-2 border-none outline-none ml-[1vw] text-white"
            >
              Delete Selected
            </span>
          </label>
        )}
        {/* <div style={{ marginBottom: "1px" }}></div> */}

        <Box sx={{ height: 588, width: "100%", background: "white", }}>
          <DataGrid
            rows={initialRows}
            columns={columns}
            editMode="row"
            checkboxSelection={enableSelection}
            rowModesModel={rowModesModel}
            onRowModesModelChange={handleRowModesModelChange}
            onRowEditStop={handleRowEditStop}
            processRowUpdate={processRowUpdate}
            onRowSelectionModelChange={(ids) => onRowsSelectionHandler(ids)}
            experimentalFeatures={{ newEditingApi: true }}
            // slots={{
            //   toolbar: EditToolbar,
            // }}
            slotProps={{
              toolbar: { setRows, setRowModesModel },
            }}
          />
        </Box>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default CategoryList;
